import React, { useState } from "react";
import classNames from "classnames";
import { Popover2 } from "@blueprintjs/popover2";
import { pickRectColor, pickViralRectColor } from "../../utils/colours";
import { Annotation } from "../../api";
import { PopoverInteractionKind } from "@blueprintjs/core";

interface AnnotationRectProps {
  selected: boolean;
  annotation: Annotation;
  isObfuscated: boolean;
  scale: number;
  scrollLeftPosition: number;
  isVirus?: boolean;
  onClick: (annotation: Annotation) => void;
}

// TODO: document the magic number
const ARROW_OFFSET = 7;

const AnnotationRect = (props: AnnotationRectProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState<boolean>(false);

  const handleClick = () => {
    props.onClick(props.annotation);
  };

  const getWidth = () => {
    return (props.annotation.absolute_end_loc - props.annotation.absolute_start_loc) * props.scale;
  };

  const getTooltipText = () => {
    if (!(props.annotation.gene && props.annotation.gene.name)) {
      return "";
    }
    return props.annotation.gene.name;
  };

  const leftFacingRect = () => {
    const arrowPointX = props.scrollLeftPosition;
    const postArrowX = arrowPointX + 10;
    const boundingX = arrowPointX + getWidth();
    const startingY = 2;
    return (
      `${arrowPointX} ${ARROW_OFFSET + startingY}, ` +
      `${postArrowX} ${startingY}, ${boundingX} ${startingY}, ` +
      `${boundingX} ${ARROW_OFFSET * 2 + startingY}, ` +
      `${postArrowX} ${ARROW_OFFSET * 2 + startingY}, ` +
      `${arrowPointX} ${ARROW_OFFSET + startingY}`
    );
  };

  const rightFacingRect = () => {
    const width = getWidth();
    const startingX = props.scrollLeftPosition;
    const preArrowX = startingX + width - 10;
    const arrowPointX = startingX + width;
    const startingY = 2;
    return (
      `${startingX} ${startingY}, ${preArrowX} ${startingY}, ` +
      `${arrowPointX} ${ARROW_OFFSET + startingY}, ` +
      `${preArrowX} ${ARROW_OFFSET * 2 + startingY}, ` +
      `${startingX} ${ARROW_OFFSET * 2 + startingY}, ` +
      `${startingX} ${ARROW_OFFSET * 2 + startingY}`
    );
  };
  const arrowPoints = props.annotation.is_forward_strand ? rightFacingRect() : leftFacingRect();

  const classes = classNames("annotation-polygon", {
    "annotation-polygon--desaturated": props.isObfuscated,
    "annotation-polygon--selected": props.selected,
  });

  const tooltipText = getTooltipText();
  return (
    <>
      <polygon
        points={arrowPoints}
        style={{
          fill: props.isVirus
            ? pickViralRectColor(props.annotation)
            : pickRectColor(props.annotation),
        }}
        onMouseOver={() => {
          setIsTooltipOpen(true);
        }}
        onMouseOut={() => {
          setIsTooltipOpen(false);
        }}
        className={classes}
        onClick={handleClick}
      />
      {tooltipText && (
        <foreignObject
          className="annotation-polygon-hover-wrapper"
          width={getWidth()}
          height={ARROW_OFFSET * 2}
          x={props.scrollLeftPosition}
          y={2}
        >
          <Popover2
            isOpen={isTooltipOpen}
            interactionKind={PopoverInteractionKind.HOVER}
            placement={"bottom"}
            popoverClassName="info-tooltip"
            content={getTooltipText()}
          >
            {/* div is needed so Popover2 knows how to center itself. */}
            <div style={{ width: `${getWidth()}px`, height: `${ARROW_OFFSET * 2}px` }} />
          </Popover2>
        </foreignObject>
      )}
    </>
  );
};

export default AnnotationRect;
